import { BaseFileUpload1 } from "../ui/ot";

// ---- 子元件：單一卡片 ----
export default function CrmFileUpload1_1({
    showComponent = ["BaseFileUpload1"],
    BaseFileUpload1Porps = []
}) {

    return (
        <>
            {
                showComponent.includes("BaseFileUpload1") && (
                    <>

                        {
                            BaseFileUpload1Porps.map((item, index) => {
                                return (
                                    <BaseFileUpload1
                                        showComponent={['MediaCard']}
                                        MediaCardPorps={[item]}
                                    />
                                )
                            })

                        }
                    </>
                )

            }
        </>

    );
}